import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Utils, { secondsToMiliseconds } from '../../utils/Utils';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import {cls, Row, Column,} from '../../packages/components';
import './styles/AAFModalConfirmPurchase60Seconds2FA.scss';
import { send2FA } from '../../requests/loader';
import Translator from '../../requests/apa/Translator';
import Asset from '../../requests/apa/Asset';
import timerManager from '../../2FA/TimerManager';
import { MINUTES_TO_REQUEST_RESENT } from '../../2FA/TimerManager';
import { showLimiteIntentos } from '../../payments/utils/Utils';
import AAFPlayer from '../../AAFPlayer/AAFPlayer';
import { AAFPLAYER_PLAY, SIGUIENTE, TELMEX2FA, MODAL60S } from '../../AAFPlayer/constants';
import DeviceStorage from '../DeviceStorage/DeviceStorage';
import ResendCodeButton2FA from '../../components/ResendCodeButton2FA/ResendCodeButton2FA';
import { HIDE_MODAL } from '../../actions/modal';
import store from '../../store';
import { pausePlayer, resumePlayer } from '../../2FA/callbacks';
import {GA4} from '../../utils/trackers/GA4';

const MAIN_CLASSNAME = 'modal-confirm-purchase-sixty-seconds';
const MAIN_TEXTNAME_CLASSNAME = 'aaf_text-confirm-purchase-sixty-seconds';

const getContentText = (key = null) => {
	const translation = Translator.get(key)
	if(translation === "" || translation === undefined){
		return key
	} else if(translation === null){
		return '\u00A0'
	}else{
		return translation
	} 
}

const GetOneText = ({phone, email}) => {
    if (phone && email) {
        return (
            <div>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje1_Parte1')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{phone}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje1_Parte3')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{email}</p>
            </div>
        );
	}
    else if (phone && !email) {
        return (
            <div>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje1_Telefono_Parte1')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{phone}</p>
            </div>
        );
    } else if (!phone && email) {
        return (
            <div>
				<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} oneText`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje1_Correo_Parte1')}</p>&nbsp;
				<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{email}</p>
			</div>
		);
    }
	return null;
}

const Title = () => (
	<Column lg={12}>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} title`)}>
			{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoTitulo')}
		</p>
	</Column>
);

const InfoImg = ({infoIcon}) => (
	<Column lg={12} className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoImg`)}>
		<img className={cls(`${MAIN_CLASSNAME} imgInfo`)} src={infoIcon} alt={infoIcon} />
	</Column>
)

const InfoText = () => (
	<div className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoText`)}>
		<p>
            {getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje2_Parte1')}{' '}
            <span className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje2_Parte2')}</span>{' '}
            {getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje2_Parte3')}
		</p>
	</div>
);

const InfoTextWithInfoImg = ({isButtonDisabled}) => {
    if (isButtonDisabled) {
        return (
            <div>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoTextWithInfoImg`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje3_Parte1')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje3_Parte2')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoTextWithInfoImg`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoMensaje3_Parte3')}</p>
            </div>
        );
    } else {
        return (
            <div>
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoTextWithInfoImg`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra2_TextoMensajeReenvio_Parte1')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textBlue`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra2_TextoMensajeReenvio_Parte2')}</p>&nbsp;
                <p className={cls(`${MAIN_TEXTNAME_CLASSNAME} infoTextWithInfoImg`)}>{getContentText('Alerta_2FATelmex_ConfirmaCompra2_TextoMensajeReenvio_Parte3')}</p>
            </div>
        );
    }
}

const HelpTitle = () => (
	<div>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} titleHelp`)}>
			{getContentText('Alerta_2FATelmex_TextoTituloAyuda')}
		</p>
	</div>
);

const HelpText1 = () => (
	<div>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
			{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoAyuda1')} 
		</p>
	</div>
)

const HelpText2 = () => (
	<div>
		<p className={cls(`${MAIN_TEXTNAME_CLASSNAME} textHelp`)}>
			{getContentText('Alerta_2FATelmex_ConfirmaCompra_TextoAyuda2')}
		</p>
	</div>
)


class AAFModalConfirmPurchase60Seconds2FA extends Component {
	constructor(props) {
		super(props);

		const dataBuyconfirm = JSON.parse(localStorage.getItem('buyConfirmData'));

        const twofaConfigMetadata=Utils.getRegionaliazedMetadata('2fa_config');
        // Timer (local, en el componente) para manejar que el botón "REENVIAR MENSAJE" de esta modal sea habilite o deshabilite.
		this.twofaConfigMetadataSecondsToResend = twofaConfigMetadata && twofaConfigMetadata.seconds_to_resend;

		this.state = {
			dataBuyconfirm,
            isButtonDisabled: true,
            maxNumResend: parseInt(DeviceStorage.getItem('max_num_resend_2FA')) || 0,
            countResend: parseInt(DeviceStorage.getItem('count_2FA')) || 0
		};

        this.timer = null;
        this.handleClick = this.handleClick.bind(this);
        this.onTimeOut = this.onTimeOut.bind(this)
        this.getSend2fa = this.getSend2fa.bind(this);
        this.paramsMetrics2FA = Utils.getParamsMetricsModals2FA(props.dataMetrics2FA, TELMEX2FA, props.history.location.pathname, MODAL60S, dataBuyconfirm && dataBuyconfirm.phone, dataBuyconfirm && dataBuyconfirm.mail);
	}

	async componentDidMount() {
        const { transactionId, check2fa } = this.state.dataBuyconfirm;

		await this.getSend2fa();

		timerManager.createTransaction(transactionId, check2fa, this.state.dataBuyconfirm, this.props.dataToShowTicket, this.paramsMetrics2FA);

        // Sólo si viene desde la modal de "Recuerda Confirmar tu Compra"
        const validateModalRemember = Boolean(localStorage.getItem("ModalRemember"))
        if (validateModalRemember) {
            timerManager.resetTimer(transactionId, MINUTES_TO_REQUEST_RESENT);
            localStorage.removeItem("ModalRemember");
        }
	}

    getSend2fa = async () => {
    	const send2faURL = this.state.dataBuyconfirm.send2fa;
		const transactionId = this.state.dataBuyconfirm.transactionId;
        const resp = await send2FA({send2faURL, transactionId});
        const maxNumResend = resp.data.max_num_resend; // SUSTITUIR POR -> resp.data.max_num_resend
        const countResend = resp.data.count; // SUSTITUIR POR -> resp.data.count
        if(this.state.maxNumResend !== maxNumResend || this.state.countResend !== countResend) this.setState({maxNumResend: maxNumResend, countResend: countResend })
    }

    sendGA4Metric(){
        const gA4 = new GA4();
        gA4.sendMetrics2FA(this.paramsMetrics2FA, SIGUIENTE);
    }

    handleClick = async (isButtonDisabled) => {
        this.sendGA4Metric();
        await this.getSend2fa();

        const countResend = parseInt(DeviceStorage.getItem("count_2FA"));
        const maxNumResend = parseInt(DeviceStorage.getItem("max_num_resend_2FA"));
        if(countResend >= maxNumResend){
            showLimiteIntentos();
            pausePlayer()
        } else if (this.state.countResend < this.state.maxNumResend) {
            this.setState({isButtonDisabled: isButtonDisabled});
            const transactionId = this.state.dataBuyconfirm.transactionId;
            timerManager.resetTimer(transactionId, MINUTES_TO_REQUEST_RESENT);
        }
    };

    handleBack = () => {
        // Al hacer BACK con el RCU.
        const transactionId = this.state.dataBuyconfirm.transactionId;
        // Se borra el timer: "minutes_to_request_resent".
        // Se mantiene el timer: "seconds_for_recurrent_call" y "minutes_to_expire_link".
        timerManager.deleteTimer(transactionId, MINUTES_TO_REQUEST_RESENT);
        resumePlayer()
    }

    onTimeOut = (isButtonDisabled) => {
        this.setState({isButtonDisabled: isButtonDisabled});
    }

	render(){
		const { dataBuyconfirm, isButtonDisabled } = this.state;

        const phone = dataBuyconfirm && dataBuyconfirm.phone;
	    const email = dataBuyconfirm && dataBuyconfirm.mail;
        const phoneAndEmail = phone !== null && email !== null;
	    const infoIcon = Asset.get('Alerta_2FATelmex_Icono_Alerta');

		return (
			<ModalWrapper className="aaf_app_modal-confirm-purchase-sixty-seconds" callbackWhenBack={this.handleBack}>
                <div className={`${MAIN_CLASSNAME} FullHD`}>
                    <Row className={cls(`${MAIN_CLASSNAME} divTitle`)}>
                        <Title />
                    </Row>
                    <Row className={cls(`${MAIN_CLASSNAME} divOneText ${phoneAndEmail ? 'changeHeight' : ''}`)}>
                        <GetOneText phone={phone} email={email} />
                    </Row>
                    <Row className={cls(`${MAIN_CLASSNAME} divInfo1 ${phoneAndEmail ? 'changeTop' : ''}`)}>
                        <InfoText/>
                    </Row>
                    <div className={cls(`${MAIN_CLASSNAME} divInfo2WithImg ${phoneAndEmail ? 'changeTop' : ''}`)}>
                        <div className='container-divInfo2WithImg'>
                            <InfoImg infoIcon={infoIcon}/>
                            <Row className={cls(`${MAIN_CLASSNAME} divInfo2 ${phoneAndEmail ? 'changeTop' : ''}`)}>
                                <InfoTextWithInfoImg isButtonDisabled={isButtonDisabled} />
                            </Row>
                        </div>
                    </div>
                    <Row className={cls(`${MAIN_CLASSNAME} divButton`)}>
                        <ResendCodeButton2FA
                            label={Translator.get('Alerta_2FATelmex_TextoBotonPrimario_Reenviar')}
                            timeToEnabled={secondsToMiliseconds(this.twofaConfigMetadataSecondsToResend)}
                            maxNumResends={this.state.maxNumResend}
                            countResends={this.state.countResend}
                            onClick={this.handleClick}
                            onTimeOut={this.onTimeOut}
                            classname='aaf_text-confirm-purchase-sixty-seconds'
                        />
                    </Row>
                    <Row className={cls(`${MAIN_CLASSNAME} divTitleHelp`)}>
                        <HelpTitle />
                    </Row>
                    <Row className={cls(`${MAIN_CLASSNAME} divTextHelp1`)}>
                        <HelpText1 />
                    </Row>
                    <Row className={cls(`${MAIN_CLASSNAME} divTextHelp2`)}>
                        <HelpText2 />
                    </Row>
                </div>
            </ModalWrapper>
		);
	}
}


AAFModalConfirmPurchase60Seconds2FA.propTypes = {
	handleClose: PropTypes.func.isRequired,
};

AAFModalConfirmPurchase60Seconds2FA.defaultProps = {
	handleClose: () => {},
};

export default withOnClose(AAFModalConfirmPurchase60Seconds2FA);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalConfirmPurchase60Seconds2FA.jsx